<script setup lang="ts">
const props = withDefaults(defineProps<{
  alt?: string
  image: string
  style?: string
}>(), {
  image: '/',
  alt: '',
  style: 'one',
})
</script>

<template>
  <div class="mpd-image" :class="style">
    <div class="outer">
      <div class="inner">
        <img :src="image" :alt="alt">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mpd-image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 2s ease;

  * {
    transition: all 2s ease;
  }

  .outer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .inner {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  &.one {
    @apply shadow-xl;
    @apply rounded-xl;
    overflow: hidden;

    .outer {
      background: var(--shade-1);
    }

    &:hover {
      @apply shadow-2xl;
      @apply rounded-2xl;
      .outer {
        > .inner {
          img {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
</style>
